export const BillStatusTranslation = {
  negotiation: 'На согласовании',
  declined: 'Отклонен',
  accepted: 'Принят',
  paid: 'Оплачен'
}